export default "__VITE_ASSET__DYQXLuwY__"